<template>
    <div class="explanation-part">
        <div
            class="afaq-qa-header"
            @click="collapse()"
            :class="collapsed && 'active'">
            <div class="afaq-question">
                <div class="drag-handle">
                    <i class="fas fa-fw fa-arrows-alt-v question-answer-drag-handle"></i>
                </div>
                <div class="question">
                    {{ questionIn.question }}
                </div>
            </div>

            <span v-for="tag in afaqTags"
                ><b-badge
                    class="badge-part-type"
                    variant="info"
                    >{{ tag.name }}
                    <!--Moet de kleur van tag.color krijgen--></b-badge
                ></span
            >

            <i class="fas fa-fw fa-chevron-down state-icon"></i>

            <b-dropdown
                class="ellipsis-nam qa-nav"
                no-caret
                variant="primary"
                right
                toggle-class="qa-context-menu">
                <template v-slot:button-content>
                    <i class="fas fa-ellipsis-v"></i>
                </template>

                <b-dropdown-item
                    class="btn-edit edit-qa"
                    @click.prevent.stop="editQA()">
                    Q&amp;A aanpassen
                </b-dropdown-item>

                <!--                <b-dropdown-item class="copy-qa" @click.prevent.stop="copyQA">-->
                <!--                    <i class="btn-duplicate"></i>Q&amp;A kopiëren-->
                <!--                </b-dropdown-item>-->

                <b-dropdown-item
                    class="remove-qa"
                    @click.prevent.stop="removeQA()">
                    <i class="btn-remove"></i>Q&amp;A verwijderen
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <b-collapse
            class="answer"
            v-model="collapsed"
            :id="'collapse-answer-' + questionIn.id"
            role="tabpanel">
            <div class="answer">
                <design-2021-apprentice-display-html-component
                    class="answer-text"
                    :html-content="questionIn.answer">
                </design-2021-apprentice-display-html-component>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { ords } from '../../../../../app';

export default {
    name: 'design-2021-afaq-question-answer-edit-component',
    props: ['questionIn'],
    data() {
        return {
            collapsed: true,
        };
    },
    computed: {
        afaqTags() {
            return this.questionIn.afaq_tags;
        },
    },
    methods: {
        collapse() {
            this.collapsed = !this.collapsed;
        },
        editQA() {
            this.$emit('editQuestion', this.questionIn);
        },
        removeQA() {
            this.alert.confirm('Q&A verwijderen', 'Weet je zeker dat je deze Q&A wil verwijderen?').then((confirm) => {
                if (!confirm) {
                    return;
                }
                this.alert.saving();
                this.axios
                    .delete(this.routes.afaqCategoryQuestion(this.questionIn.afaq_category_id), {
                        data: { questionId: this.questionIn.id },
                    })
                    .then(
                        (response) => {
                            this.questionIn.remove();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
            });
        },
    },
};
</script>

<style scoped></style>
